import { Pipe, PipeTransform } from '@angular/core';
import { OrderStatus } from '../enums/order-status.enum';
import { getVintedGoStatusLabels } from '../helpers/vintedgo-status-label.util';

@Pipe({
  name: 'shipmentStatusLabelPipe',
  pure: true
})
export class ShipmentStatusLabelPipe implements PipeTransform {

  private readonly statusLabels: Record<number, string> = {
    // --- Legacy / Core Statuses ---
    [OrderStatus.NEW]: 'New',
    [OrderStatus.COLLECTED]: 'Collected',
    [OrderStatus.IN_TRANSIT]: 'In Transit',
    [OrderStatus.DELIVERED]: 'Delivered',
    [OrderStatus.PENDING_COLLECTION]: 'Pending Collection',
    [OrderStatus.PENDING_CUSTOMER_COLLECTION]: 'Pending Customer Collection',
    [OrderStatus.DELIVERY_ATTEMPT_FAILED]: 'Delivery Attempt Failed',
    [OrderStatus.DELIVERY_ADDRESS_CHANGED]: 'Delivery Address Changed',
    [OrderStatus.DELIVERY_REFUSED]: 'Delivery Refused',
    [OrderStatus.CUSTOM_DELAY]: 'Customs Delay',
    [OrderStatus.SHIPMENT_DELAYED]: 'Shipment Delayed',
    [OrderStatus.DELAYED_DUE_PAYMENT]: 'Delayed Due to Payment',
    [OrderStatus.INCORRECT_ADDRESS]: 'Incorrect Address',
    [OrderStatus.SHIPMENT_REJECTED]: 'Shipment Rejected',
    [OrderStatus.SHIPMENT_RETURNED]: 'Shipment Returned',
    [OrderStatus.SHIPMENT_LOST]: 'Shipment Lost',
    [OrderStatus.SHIPMENT_ARRIVED_DESTINATION_PORT]: 'Arrived at Destination Port',
    [OrderStatus.CUSTOM_CLEARED]: 'Customs Cleared',
    [OrderStatus.CUSTOM_CLEARANCE_PROCESS]: 'Customs Clearance Process',
    [OrderStatus.SHIPMENT_BACK_2_TRANSIT]: 'Back in Transit',
    [OrderStatus.NEW_ADDRESS_RECEIVED]: 'New Address Received',
    [OrderStatus.DELIVERY_IN_PROCESS]: 'Delivery in Process',
    [OrderStatus.SHIPMENT_CANCELED]: 'Shipment Canceled',
    [OrderStatus.DELAYED]: 'Delayed',
    [OrderStatus.PENDING_DELIVERY]: 'Pending Delivery',
    [OrderStatus.CANCELED]: 'Canceled',
    [OrderStatus.UPDATE]: 'Update Required',
    [OrderStatus.REORDER]: 'Reorder',
    [OrderStatus.EARLY_CANCELATION]: 'Early Cancelation',
    [OrderStatus.PENDING]: 'Pending',
    [OrderStatus.ABANDODED_CHECKOUT]: 'Abandoned Checkout',
    [OrderStatus.PAYMENT_DECLINED]: 'Payment Declined',
    [OrderStatus.CLOSED]: 'Closed',
    [OrderStatus.PARTIAL_SHIPMENT]: 'Partial Shipment',
    [OrderStatus.PAID]: 'Paid',

    // --- Operational & Warehouse Workflow ---
    [OrderStatus.DRAFT]: 'Draft',
    [OrderStatus.DOCUMENT_INSPECTION]: 'Document Inspection',
    [OrderStatus.AWAITING_FOR_OPERATION_APPROVAL]: 'Awaiting Operation Approval',
    [OrderStatus.AWAITING_FOR_FRONT_DESK_APPROVAL]: 'Awaiting Front Desk Approval',
    [OrderStatus.AWAITING_FOR_COLLECTION]: 'Awaiting Collection',
    [OrderStatus.EXPORT_CLEARANCE]: 'Export Clearance',
    [OrderStatus.ETA_LESS_THAN_3_DAYS]: 'ETA < 3 Days',
    [OrderStatus.DELIVERY_TO_WH_IN_PROGRESS]: 'Delivery to Warehouse in Progress',
    [OrderStatus.DELIVERY_TO_WH_PENDING]: 'Delivery to Warehouse Pending',
    [OrderStatus.DELIVERY_TO_WH_COMPLETED]: 'Delivery to Warehouse Completed',
    [OrderStatus.REPACKING]: 'Repacking',
    [OrderStatus.LAST_MILE_SCHEDULE]: 'Last Mile Scheduled',
    [OrderStatus.LAST_MILE_IN_TRANSIT]: 'Last Mile in Transit',
    [OrderStatus.DELIVERY_TO_CLIENT_IN_PROCESS]: 'Delivery to Client in Process',
    [OrderStatus.DELIVERY_TO_CLIENT_PENDING]: 'Delivery to Client Pending',
    [OrderStatus.DELIVERY_TO_CLIENT_REFUSED]: 'Delivery to Client Refused',
    [OrderStatus.AWAITING_FINAL_DOCS_TO_SYSTEM]: 'Awaiting Final Docs',
    [OrderStatus.COMPLETED]: 'Completed',

    // --- AfterShip Pending (101-106) ---
    [OrderStatus.PENDING_001]: 'Pending',
    [OrderStatus.PENDING_002]: 'Carrier account not connected',
    [OrderStatus.PENDING_003]: 'Label created, no updates yet',
    [OrderStatus.PENDING_004]: 'Wrong carrier',
    [OrderStatus.PENDING_005]: 'No recent updates',
    [OrderStatus.PENDING_006]: 'Unrecognized carrier',

    // --- AfterShip Info Received (111) ---
    [OrderStatus.INFORECEIVED_001]: 'Info Received',

    // --- AfterShip In Transit (121-129) ---
    [OrderStatus.INTRANSIT_001]: 'In Transit',
    [OrderStatus.INTRANSIT_002]: 'Acceptance scan',
    [OrderStatus.INTRANSIT_003]: 'Arrival scan',
    [OrderStatus.INTRANSIT_004]: 'Arrived at destination country',
    [OrderStatus.INTRANSIT_005]: 'Customs clearance completed',
    [OrderStatus.INTRANSIT_006]: 'Customs clearance started',
    [OrderStatus.INTRANSIT_007]: 'Departure Scan',
    [OrderStatus.INTRANSIT_008]: 'Problem resolved',
    [OrderStatus.INTRANSIT_009]: 'Forwarded to address',

    // --- AfterShip Out for Delivery (131-134) ---
    [OrderStatus.OUTFORDELIVERY_001]: 'Out for Delivery',
    [OrderStatus.OUTFORDELIVERY_003]: 'Customer contacted',
    [OrderStatus.OUTFORDELIVERY_004]: 'Delivery appointment scheduled',

    // --- AfterShip Attempt Fail (141-143) ---
    [OrderStatus.ATTEMPTFAIL_001]: 'Failed Attempt',
    [OrderStatus.ATTEMPTFAIL_002]: 'Addressee not available',
    [OrderStatus.ATTEMPTFAIL_003]: 'Business Closed',

    // --- AfterShip Delivered (151-154) ---
    [OrderStatus.DELIVERED_001]: 'Delivered',
    [OrderStatus.DELIVERED_002]: 'Picked up by customer',
    [OrderStatus.DELIVERED_003]: 'Signed by customer',
    [OrderStatus.DELIVERED_004]: 'Delivered (COD)',

    // --- AfterShip Available for Pickup (161) ---
    [OrderStatus.AVAILABLEFORPICKUP_001]: 'Available for pickup',

    // --- AfterShip Exceptions (171-184) ---
    [OrderStatus.EXCEPTION_001]: 'Exception',
    [OrderStatus.EXCEPTION_002]: 'Customer moved',
    [OrderStatus.EXCEPTION_003]: 'Customer refused delivery',
    [OrderStatus.EXCEPTION_004]: 'Delayed (Customs)',
    [OrderStatus.EXCEPTION_005]: 'Delayed (External)',
    [OrderStatus.EXCEPTION_006]: 'Held for payment',
    [OrderStatus.EXCEPTION_007]: 'Incorrect Address',
    [OrderStatus.EXCEPTION_008]: 'Pick up missed',
    [OrderStatus.EXCEPTION_009]: 'Rejected by carrier',
    [OrderStatus.EXCEPTION_010]: 'Returning to sender',
    [OrderStatus.EXCEPTION_011]: 'Returned to sender',
    [OrderStatus.EXCEPTION_012]: 'Shipment damage',
    [OrderStatus.EXCEPTION_013]: 'Shipment lost',
    [OrderStatus.EXCEPTION_014]: 'Carrier pickup failed',

    // --- AfterShip Expired (191) ---
    [OrderStatus.EXPIRED_001]: 'Expired',

    // --- VintedGo statuses (192-219) — labels from Vinted status_code ---
    ...getVintedGoStatusLabels(OrderStatus),
  };

  transform(value: number | string): string {
    const statusNumber = typeof value === 'string' ? parseInt(value, 10) : value;
    return this.statusLabels[statusNumber] || `Unknown (${statusNumber})`;
  }
}